<template>
    <span>
        <Cadastro-Usuarios-Adicionar-Escola></Cadastro-Usuarios-Adicionar-Escola>
    </span>
</template>

<script>
import CadastroUsuariosAdicionarEscola from '@/components/Cadastro-Usuarios-Adicionar-Escola';

export default {
    name: 'cadusuariosaddescola',
    components: {
        CadastroUsuariosAdicionarEscola
    }
};
</script>